define([
	"csi/service/fontService",
	"./_TextStyle",
	"./PluginFactory"
], function(fontService, _TextStyle, PluginFactory) {

	return PluginFactory.declare(_TextStyle, {
		"class": "csi-button-toggle",
		cssValue: "font-style",
		materialIcon: "format_italic",
		pluginName: "italic",
		title: "CanvasItalic",
		isItalic: false,

		/**
		 * Update plugin value and disabled status based on selected shapes and attributes
		 * @param  {Shape[]} shapes
		 * @param  {Object} shapeAttrs
		 * @param  {Object} textAttrs
		 * @return {Boolean}
		 */
		enablePlugin: function(shapes, shapeAttrs, textAttrs) {
			const { cssValue, editor, pluginName } = this;
			if (shapes && shapes.length && editor.isSelectCanvasMode()) {
				this.isItalic = editor.canvasApp.selection.getCommonTextValue(shapes, cssValue, true) === pluginName;
			} else if (editor.isEditTextCanvasMode()) {
				this.isItalic = fontService.getFroalaSelectionSpanStyle(cssValue) === pluginName;
			}
			this.set("checked", this.isItalic, false);
			return true;
		},

		/**
		 * Apply style
		 * @param  {Event} e
		 */
		onClick: function(e) {
			this.editor.setTextStyle(this.cssValue, "italic", this.checked);
		}
	});
});
